import { useCallback, useEffect, useState } from 'react';
import { getCampaignLimits } from 'services/MailingService';
import {
    isValidCampaignLimitsData,
    selectMarketingCampaignLimitsViewModel,
} from '../utils/marketingCampaignLimitsViewModel';

export function useMarketingCampaignLimits({ enabled = true } = {}) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchLimits = useCallback(() => {
        setLoading(true);
        setError(null);

        return getCampaignLimits()
            .then((response) => {
                if (!isValidCampaignLimitsData(response)) {
                    setData(null);
                    setError(new Error('Invalid campaign limits data'));
                    return null;
                }

                setData(response);
                return response;
            })
            .catch((fetchError) => {
                setData(null);
                setError(fetchError);
                return null;
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        if (!enabled) {
            return;
        }

        fetchLimits();
    }, [enabled, fetchLimits]);

    const viewModel = data ? selectMarketingCampaignLimitsViewModel(data) : null;

    return {
        data,
        viewModel,
        loading,
        error,
        refresh: fetchLimits,
    };
}
